const model = {
    countries: [],
    loading: false,
    error: null,
};

export default model;
